import { PriceFormatter } from '@estee/elc-formatters';
import Config from '../domain/entities/Config/Config';

const CANADA_LOCALE_SUFIX = '-CA';
const US_LOCALE_SUFIX = '-US';
const TR_LOCALE = 'tr-TR';
const MY_LOCALE = 'en-MY';
const VN_LOCALE = 'vi-VN';
const CL_LOCALE = 'es-CL';
const DK_LOCALE = 'da-DK';
const NO_LOCALE = 'no-NO';
const BE_LOCALE = 'nl-BE';
const SE_LOCALE = 'sv-SE';
const CZ_LOCALE = 'cs-CZ';
const DECIMAL_SEPARATOR = '.';
const space = ' ';

const REVERSE_CURRENCY_SYMBOL_LOCALES = [DK_LOCALE, NO_LOCALE, BE_LOCALE];
const HIDE_DECIMAL_LOCALES = [SE_LOCALE, DK_LOCALE, NO_LOCALE];
const REPLACE_SEPARATOR_LOCALES = [CZ_LOCALE];

export default function formatPrice(config: Config, price: number): string {
  const { currency, locale } = config;
  const decimalSeparator = REPLACE_SEPARATOR_LOCALES.includes(locale) ? DECIMAL_SEPARATOR : '';

  const priceFormatter = new PriceFormatter({
    currency,
    decimalSeparator,
    hideZeroDecimals: HIDE_DECIMAL_LOCALES.includes(locale),
    locale: locale.endsWith(CANADA_LOCALE_SUFIX)
      ? locale.replace(CANADA_LOCALE_SUFIX, US_LOCALE_SUFIX)
      : locale,
  });

  if (locale === TR_LOCALE) {
    const turkishPrice = priceFormatter.formatPriceWithCurrency(price).replace('.', '').replace(/,/g, '.').replace('₺', 'TL');
    return price >= 0
      ? turkishPrice.substr(2) + space + turkishPrice.substr(0, 2)
      : turkishPrice.substr(0, 1) + turkishPrice.substr(3) + space + turkishPrice.substr(1, 2);
  }

  if (locale === MY_LOCALE) {
    return priceFormatter.formatPriceWithCurrency(price).replace(/\s/g, '');
  }

  if (locale === VN_LOCALE) {
    return new PriceFormatter({ currency, locale, numberOfDecimals: 2 }).formatPriceWithCurrency(price).replace(/\D00(?=\D*$)/, '');
  }

  if (locale === CL_LOCALE) {
    return priceFormatter.formatPriceWithCurrency(price).replace(/^(\$)?-([\d,.]+)/, '-$1$2');
  }

  if (REVERSE_CURRENCY_SYMBOL_LOCALES.includes(locale)) {
    const splitFormattedPrice = priceFormatter.formatPriceWithCurrency(price).split(/\s/);
    const currencySymbol = splitFormattedPrice[0];
    const amount = splitFormattedPrice.slice(1).join('');

    return locale === BE_LOCALE ? `${amount}${currencySymbol}` : `${amount} ${currencySymbol}`;
  }

  if (REPLACE_SEPARATOR_LOCALES.includes(locale)) {
    // Replace space with ',' unless it's the space before the currency symbol.
    return priceFormatter.formatPriceWithCurrency(price).split('').map(
      (elem, i, { length }) => /\s/.test(elem) && !(i === length - 3) ? ',' : elem,
    ).join('');
  }

  return priceFormatter.formatPriceWithCurrency(price);
}
